import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Navbar.css';
import logo3 from "../../Assets/logo1.svg";
import humbergerIcon from '../../Assets/icons/humberger-icon.png';
import PrimeryButton from '../../ControlledComponents/PrimeryButton/PrimeryButton';
import Button4 from '../button3';

const Navbar = () => {
    const { t, i18n } = useTranslation();

    const [isActive, setIsActive] = useState(0);
    const [navOpen, setNavOpen] = useState(false);

    const navLinks = [
        { key: 'home', link: '/' },
        { key: 'about', link: '/about-us' },
        { key: 'portfolio', link: '/our-projects' },
        { key: 'services', link: '/services' },
    ];

    const location = useLocation();
    const navigate = useNavigate();

    const navigateToContact = () => {
        setIsActive(-1);
        navigate(`/contact-us`);
    };

    useEffect(() => {
        if (location.pathname === '/contact-us') {
            setIsActive(-1);
        } else {
            const currentIndex = navLinks.findIndex(item => item.link === location.pathname);
            setIsActive(currentIndex !== -1 ? currentIndex : 0);
        }
    }, [location.pathname]);

    const handleNavActive = (index) => {
        setIsActive(index);
    };

    const handleNavOpen = () => {
        setNavOpen(!navOpen);
    };

    const toggleLanguage = () => {
        const newLang = i18n.language === 'en' ? 'ar' : 'en';
        i18n.changeLanguage(newLang);
        document.body.dir = newLang === 'ar' ? 'rtl' : 'ltr';
    };

    return (
        <div className='navbar-main-container'>
            <div className='navbar-inner-container'>
                <div className='navbar-logo-section'>
                    <Link to='/'>
                        <img src={logo3} alt='logo' />
                    </Link>
                </div>
                <div className='navbar-links-section'>
                    {navLinks.map((item, index) => (
                        <Link
                            key={index}
                            to={item.link}
                            className={`navbar-link-anchor ${isActive === index ? 'navbar-link-active-anchor' : ''}`}
                            onClick={() => handleNavActive(index)}
                        >
                            {t(`navbar.${item.key}`)}
                        </Link>
                    ))}
                </div>
                <div className='navbar-contact-btn-section'>
                    <Button4
                        text_1={t('navbar.contact')}
                        text_2={t('navbar.contact')}
                        width={'173px'}
                        height={'50px'}
                        fontSize={'18px'}
                        lineHeight={'22px'}
                        fontWeight={'400'}
                        color={'#fff'}
                        navigateClick={navigateToContact}
                    />
                </div>
                <div className='lang-toggle-section'>
                    <button onClick={toggleLanguage} className='lang-btn'>
                        {i18n.language === 'en' ? '🇸🇦 العربية' : '🇺🇸 English'}
                    </button>
                </div>
            </div>

            {/* Mobile Navbar */}
            <div className={`mobile-navbar-inner-container ${navOpen ? "open" : ""}`}>
                <div className="headerSection_mobile_view">
                    <Link to='/'><img src={logo3} alt='main logo' className='mobile-main-logo' /></Link>
                    <img src={humbergerIcon} alt='nav-toggle' className='mobile-humberger-icon' onClick={handleNavOpen} />
                </div>

                {navOpen && (
                    <div className='navbar-links-section'>
                        {navLinks.map((item, index) => (
                            <Link
                                key={index}
                                to={item.link}
                                className={`navbar-link-anchor ${isActive === index ? 'navbar-link-active-anchor' : ''}`}
                                onClick={() => {
                                    handleNavActive(index);
                                    setNavOpen(false);
                                }}
                            >
                                {t(`navbar.${item.key}`)}
                            </Link>
                        ))}
                        <div className='navbar-contact-btn-section'>
                            <PrimeryButton
                                text={t('navbar.contact')}
                                width={'173px'}
                                height={'50px'}
                                fontSize={'18px'}
                                lineHeight={'22px'}
                                fontWeight={'400'}
                                color={'#fff'}
                                navigateClick={() => {
                                    navigateToContact();
                                    setNavOpen(false);
                                }}
                            />
                        </div>
                        <div className='lang-toggle-section'>
                            <button onClick={toggleLanguage} className='lang-btn'>
                                {i18n.language === 'en' ? '🇸🇦 العربية' : '🇺🇸 English'}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Navbar;
